import { Cloud, Brain, Shield, TrendingDown, Map } from 'lucide-react';

export const AboutSection = () => {
  const expertiseAreas = [
    { icon: Cloud, label: 'Multi-cloud architecture strategy' },
    { icon: Brain, label: 'AI/LLM infrastructure optimization' },
    { icon: Shield, label: 'DevSecOps and SRE practices' },
    { icon: TrendingDown, label: 'Cost reduction (60-70% savings)' },
    { icon: Map, label: 'Cloud modernization roadmaps' },
  ];

  return (
    <section className="py-20 md:py-32 bg-[#F8F9FA]" data-testid="about-section">
      <div className="max-w-[1200px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-16 items-center">
          {/* Image */}
          <div className="relative order-2 md:order-1">
            <div className="absolute -inset-4 bg-[#2C3E50]/5 rounded-2xl" />
            <img
              src="https://customer-assets.emergentagent.com/job_e450bca2-37df-4eee-b764-211a4cfae415/artifacts/my5izqnl_linkedin.png"
              alt="Siddharth Kaul"
              className="relative w-full h-[350px] md:h-[450px] object-cover rounded-xl"
            />
          </div>

          {/* Content */}
          <div className="space-y-6 order-1 md:order-2">
            <div className="space-y-4">
              <p className="text-[#3498DB] font-semibold tracking-[0.2em] uppercase text-sm">
                About
              </p>
              <h2 className="font-['Montserrat'] font-bold text-3xl md:text-4xl text-[#2C3E50]">
                Who I Am
              </h2>
            </div>

            <p className="text-[#64748B] leading-relaxed">
              I'm Siddharth Kaul, a cloud and AI infrastructure consultant specializing in enterprise-scale transformations. With experience across Fortune 500 technology implementations, I help organizations navigate:
            </p>

            <ul className="space-y-4">
              {expertiseAreas.map((area, index) => (
                <li key={index} className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-lg bg-[#3498DB]/10 flex items-center justify-center flex-shrink-0">
                    <area.icon className="text-[#3498DB]" size={20} />
                  </div>
                  <span className="text-[#2C3E50] font-medium">{area.label}</span>
                </li>
              ))}
            </ul>

            <div className="pt-4 border-t border-slate-200">
              <p className="text-[#64748B] leading-relaxed">
                My approach combines deep technical expertise with practical implementation roadmaps, delivering measurable ROI within 90 days.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
